/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createRepository = /* GraphQL */ `mutation CreateRepository($input: CreateRepositoryInput!) {
  createRepository(input: $input) {
    assessmentUrl
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRepositoryMutationVariables,
  APITypes.CreateRepositoryMutation
>;
export const createEngineer = /* GraphQL */ `mutation CreateEngineer($input: EngineerInput) {
  createEngineer(input: $input) {
    id
    owner
    experience
    positionTitleTypes
    skillIds
    cv {
      bucket
      region
      key
      pathPrefix
      __typename
    }
    linkedIn
    phase
    utm {
      source
      medium
      campaign
      term
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEngineerMutationVariables,
  APITypes.CreateEngineerMutation
>;
export const createOrUpdateJobMatch = /* GraphQL */ `mutation CreateOrUpdateJobMatch($input: JobMatchInput!) {
  createOrUpdateJobMatch(input: $input) {
    id
    engineerId
    openPositionId
    engineerInterest
    status
    inactiveMatchReason
    openPosition {
      id
      name
      company {
        id
        name
        url
        logoUrl
        summary
        __typename
      }
      titleType
      role
      active
      experience
      diagnostics {
        items {
          id
          openPositionId
          diagnosticId
          diagnostic {
            id
            name
            assessment
            description
            type
            category
            image
            __typename
          }
          position {
            id
            name
            titleType
            role
            active
            experience
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      skills {
        items {
          id
          openPositionId
          skillId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateJobMatchMutationVariables,
  APITypes.CreateOrUpdateJobMatchMutation
>;
export const createOrUpdateEngineerDiagnostic = /* GraphQL */ `mutation CreateOrUpdateEngineerDiagnostic($input: EngineerDiagnosticInput!) {
  createOrUpdateEngineerDiagnostic(input: $input) {
    id
    engineerId
    diagnosticId
    order
    assessmentUrl
    canceledAt
    readyAt
    diagnostic {
      id
      name
      assessment
      description
      type
      category
      image
      openPositions {
        items {
          id
          openPositionId
          diagnosticId
          diagnostic {
            id
            name
            assessment
            description
            type
            category
            image
            __typename
          }
          position {
            id
            name
            titleType
            role
            active
            experience
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateEngineerDiagnosticMutationVariables,
  APITypes.CreateOrUpdateEngineerDiagnosticMutation
>;
export const batchCreateSkillsDeclarationSkills = /* GraphQL */ `mutation BatchCreateSkillsDeclarationSkills(
  $skillsDeclarationId: ID!
  $skillIds: [ID!]!
) {
  batchCreateSkillsDeclarationSkills(
    skillsDeclarationId: $skillsDeclarationId
    skillIds: $skillIds
  ) {
    id
    skillsDeclarationId
    skillId
    skillsDeclaration {
      id
      backendLevel
      frontendLevel
      mobileLevel
      skills {
        items {
          id
          skillsDeclarationId
          skillId
          skillsDeclaration {
            id
            backendLevel
            frontendLevel
            mobileLevel
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          skill {
            id
            name
            type
            area
            active
            frequency
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    skill {
      id
      name
      type
      area
      active
      frequency
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.BatchCreateSkillsDeclarationSkillsMutationVariables,
  APITypes.BatchCreateSkillsDeclarationSkillsMutation
>;
export const updateEngineer = /* GraphQL */ `mutation UpdateEngineer(
  $input: UpdateEngineerInput!
  $condition: ModelEngineerConditionInput
) {
  updateEngineer(input: $input, condition: $condition) {
    id
    owner
    experience
    positionTitleTypes
    skillIds
    cv {
      bucket
      region
      key
      pathPrefix
      __typename
    }
    linkedIn
    phase
    utm {
      source
      medium
      campaign
      term
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEngineerMutationVariables,
  APITypes.UpdateEngineerMutation
>;
export const syncEngineerDiagnostic = /* GraphQL */ `mutation SyncEngineerDiagnostic($input: EngineerDiagnosticSyncInput) {
  syncEngineerDiagnostic(input: $input)
}
` as GeneratedMutation<
  APITypes.SyncEngineerDiagnosticMutationVariables,
  APITypes.SyncEngineerDiagnosticMutation
>;
export const syncEngineer = /* GraphQL */ `mutation SyncEngineer($input: EngineerSyncInput) {
  syncEngineer(input: $input)
}
` as GeneratedMutation<
  APITypes.SyncEngineerMutationVariables,
  APITypes.SyncEngineerMutation
>;
export const syncJobMatch = /* GraphQL */ `mutation SyncJobMatch($input: JobMatchSyncInput) {
  syncJobMatch(input: $input)
}
` as GeneratedMutation<
  APITypes.SyncJobMatchMutationVariables,
  APITypes.SyncJobMatchMutation
>;
